import axios from 'axios';
import Constants from '../common/constants';

const serviceTypeService = {
    getAll: (page = 0, size = 50) =>
        axios.get(`${Constants.API_BASE_URL}/queue/service-type?page=${page}&size=${size}`),

    getAllActive: () =>
        axios.get(`${Constants.API_BASE_URL}/queue/service-type/active`),

    getById: (id) =>
        axios.get(`${Constants.API_BASE_URL}/queue/service-type/${id}`),
};

export default serviceTypeService;
